import Component from '@glimmer/component';
import pageTitle from 'ember-page-title/helpers/page-title';
import { PhCheckCircle, PhClockCountdown, PhLinkBreak } from 'ember-phosphor-icons';
import { t } from 'ember-intl';
import Button from 'tio-ui/components/button';
import Heading from 'tio-ui/components/heading';
import IconBadge from 'tio-ui/components/icon-badge';
import TioFooter from 'tio-common/components/tio/footer';
import type { LinkLandingStatus } from 'tio-employee/routes/phone-verified';

interface PhoneVerifiedSignature {
  Args: {
    model: { status: LinkLandingStatus };
  };
}

const ICONS = {
  ok: { icon: PhCheckCircle, color: 'green' },
  expired: { icon: PhClockCountdown, color: 'amber' },
  invalid: { icon: PhLinkBreak, color: 'gray' },
} as const;

export default class PhoneVerifiedPage extends Component<PhoneVerifiedSignature> {
  get status() {
    return this.args.model.status;
  }

  get badge() {
    return ICONS[this.status];
  }

  get copy() {
    const base = `phone_verification.link_landing.${this.status}`;

    return { title: `${base}.title`, body: `${base}.body`, cta: `${base}.cta` };
  }

  <template>
    {{pageTitle (t "phone_verification.link_landing.page_title")}}

    <div class="tio-col-flush min-h-screen tio-bg-sunken">
      <main class="tio-place-center grow px-4 py-10">
        <section
          class="tio-col w-full max-w-md tio-bg-surface tio-elevation-card rounded-md p-8 items-center text-center"
          data-test-phone-verified={{this.status}}
        >
          <IconBadge @icon={{this.badge.icon}} @color={{this.badge.color}} @size="lg" />
          <Heading @level={{1}}>
            {{t this.copy.title}}
          </Heading>
          <p class="tio-fg-muted">
            {{t this.copy.body}}
          </p>
          <Button
            @route="login"
            @intent="primary"
            class="w-full sm:w-auto"
            data-test-phone-verified-continue
          >
            {{t this.copy.cta}}
          </Button>
        </section>
      </main>
      <TioFooter />
    </div>
  </template>
}
